// Silvester Countdown Widget
import React, { useState, useEffect, memo } from 'react';

export const SilvesterCountdownWidget = memo(function SilvesterCountdownWidget() {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  
  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const currentYear = now.getFullYear();
      const newYear = new Date(currentYear + 1, 0, 1, 0, 0, 0);
      const diff = newYear - now;
      
      if (diff > 0) {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        setTimeLeft({ days, hours, minutes, seconds });
      }
    };
    
    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="countdown-widget-glass">
      <div className="countdown-widget-header">
        <svg className="countdown-icon" viewBox="0 0 24 24" width="18" height="18">
          <defs>
            <linearGradient id="iconGlow" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#00ffd5" />
              <stop offset="100%" stopColor="#00d4ff" />
            </linearGradient>
          </defs>
          <circle cx="12" cy="12" r="2" fill="url(#iconGlow)" />
          <path d="M12 2v4M12 18v4M2 12h4M18 12h4" stroke="url(#iconGlow)" strokeWidth="2" strokeLinecap="round" />
          <path d="M5.64 5.64l2.83 2.83M15.54 15.54l2.83 2.83M5.64 18.36l2.83-2.83M15.54 8.46l2.83-2.83" stroke="url(#iconGlow)" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
        <span className="countdown-widget-year">{new Date().getFullYear() + 1}</span>
      </div>
      <div className="countdown-widget-timer">
        <div className="countdown-widget-block">
          <span className="countdown-widget-num">{String(timeLeft.days).padStart(2, '0')}</span>
          <span className="countdown-widget-txt">Tage</span>
        </div>
        <span className="countdown-widget-sep">:</span>
        <div className="countdown-widget-block">
          <span className="countdown-widget-num">{String(timeLeft.hours).padStart(2, '0')}</span>
          <span className="countdown-widget-txt">Stunden</span>
        </div>
        <span className="countdown-widget-sep">:</span>
        <div className="countdown-widget-block">
          <span className="countdown-widget-num">{String(timeLeft.minutes).padStart(2, '0')}</span>
          <span className="countdown-widget-txt">Minuten</span>
        </div>
        <span className="countdown-widget-sep">:</span>
        <div className="countdown-widget-block">
          <span className="countdown-widget-num">{String(timeLeft.seconds).padStart(2, '0')}</span>
          <span className="countdown-widget-txt">Sekunden</span>
        </div>
      </div>
    </div>
  );
});
